import { useEffect, useState } from 'react';
import { getSentences } from '../../database/getSentence';
import Field from './Field';
import { sentenceState } from '../../globalStates/gameMain/sentence';
import { useRecoilState, useRecoilValue, useSetRecoilState } from 'recoil';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { loadingState } from '../../globalStates/general/loading';
import { fieldDataState } from '../../globalStates/general/fieldData';
import { player1CurrentSquaresState } from '../../globalStates/general/player1CurrentSquare';
import { player1HasWordsState } from '../../globalStates/general/hasWords';
import BackPack from './BackPack';
import { gameStatusInfoState } from '../../globalStates/general/gameStatusInfo';
import HoneycombSet from '../HoneyComb/HoneycombSet';
import Sentence from '../Sentence';
import Items from './Item/Items';
import Loading from './LoadingField';
import { useLocation } from 'react-router-dom';
import { gameStatusState } from '../../globalStates/general/gameStatus';
import WarpWindow from './Item/WarpWindow';
import SentenceWindow from './SentenceWindow';
import TrapMain, { trapIdListForRandom, trapIdToNameTable } from './Trap/TrapMain';
import { addSentencesData } from '../../database/addSentencesData';
import { returnSentence } from '../../data/returnSentence';
import GameOver from '../GameOver';
import { teacherIdState } from '../../globalStates/general/teacherId';
import { getOriginalSentence } from '../../database/getOriginalSentence';
import { levelState } from '../../globalStates/general/level';
import Honeycomb from '../../images/honeycomb.png';

import { useMedia } from 'use-media';



const TeacherGameMain = (props) => {
  const [gameStatusValue, setGameStatusValue] = useRecoilState(gameStatusState);
  const [sentence, setSentence] = useRecoilState(sentenceState);
  const [isLoading, setIsLoading] = useRecoilState(loadingState);
  // フィールドのデータを管理する
  const [fieldData, setFieldData] = useRecoilState(fieldDataState);
  // playerがいるマスの場所(start: 0)
  const [playerCurrentSquare, setPlayerCurrentSquare] = useRecoilState(player1CurrentSquaresState);
  // イージーモードのプレイヤーが持っている単語のstate
  const [playerHasWords, setPlayerHasWords] = useRecoilState(player1HasWordsState);
  // ユーザーに提示するためのゲームの状態
  const [gameStatusInfo, setGameStatusInfo] = useRecoilState(gameStatusInfoState);
  // フィールドが作成されたか　作成されるとローディング画面からゲーム画面に遷移する
  const [isFieldCreated, setIsFieldCreated] = useState(false);
  const [level, setLevel] = useRecoilState(levelState);

  const [cnt, setCnt] = useState();
  const [teacherId, setTeacherId] = useRecoilState(teacherIdState);
  const isPC = useMedia({ minWidth: '1000px' });
  const [actionWindowDisplay, setActionWindowDisplay] = useState("none");

  let obj_len;

  useEffect(() => {
    switch (gameStatusValue) {
      case 0:
        window.alert("アクセスできません。");
        window.location.replace("/");
        break;
    }
  }, []);

  // 難易度によって変わる値　(初期値はeasy)
  const fieldSettings = {
    field_len: 11,
    trap_len: 5,
    min: 0,
    max: 0,
  }
  if (level == "easy") {
    fieldSettings.field_len = 17;
    fieldSettings.trap_len = 5;
  } else if (level == "normal") {
    fieldSettings.field_len = 30;
    fieldSettings.trap_len = 10;
  } else if (level == "hard") {
    fieldSettings.field_len = 35;
    fieldSettings.trap_len = 12;
  }

  function getRandomInt(min, max) {
    min = Math.ceil(min);
    max = Math.floor(max) + 1;
    return Math.floor(Math.random() * (max - min) + min); //The maximum is exclusive and the minimum is inclusive
  }

  // フィールドを作成する
  const createFieldDataArray = async () => {
    setIsLoading(true);
    setIsFieldCreated(false);
    const field_data_arr = [];

    //gridが埋まっているかどうかを判定する配列
    const fieldIndex = [];

    const sentenceId = getRandomInt(fieldSettings.min, fieldSettings.max);
    // console.log(sentenceId);
    // const sentenceId = 126;

    //startマスの設定
    field_data_arr[0] = {
      isNextGrid: false,
      isWord: false,
      isTrap: false,
      contents: "start",
      player: "player1"
    }

    // ランダムに単語を振り分ける→トラップをランダムに割り当てる

    // 何もないマスを配置
    for (let i = 1; i < fieldSettings.field_len + 1; i++) {
      fieldIndex[i] = i;
      field_data_arr[i] = {
        isNextGrid: false, isWord: false, isTrap: false, contents: "", player: "", checked: "",
      }
    }

    const getFieldRandomIndex = () => {
      let randI;
      while (1) {
        //ランダムなindexを取得
        const fieldI = 1 + Math.floor(Math.random() * fieldIndex.length);
        randI = fieldIndex[fieldI];
        if (randI != undefined && randI != 0 && randI && randI != null && fieldIndex[fieldI] != "word") {
          fieldIndex[fieldI] = "word";
          // i番目の要素を削除
          fieldIndex.splice(fieldI, 1);
          break;
        }
      }
      return randI;
    }

    obj_len = Object.keys(await getOriginalSentence(teacherId)).length;
    if (obj_len === 0) {
      window.alert("オリジナル文が設定されていないことを先生にお伝えください。");
      window.location.href = '/';
    }
    // 単語の配置
    const randomSentenceId = getRandomInt(1, obj_len);
    await getOriginalSentence(teacherId, randomSentenceId).then((data) => {
      console.log(randomSentenceId);

      setSentence(data);
      let cnt = 0; //　長さ
      for (let i = 1; i < 8; i++) {
        if (data[i].word_bottom) {
          if (data[i].word_bottom == "　") {
            data[i].word_bottom.replace("　", "");
            continue;
          }
          cnt++;
        }
        if (data[i].word_top && i != 2) {
          if (data[i].word_top == "　") {
            data[i].word_top.replace("　", "");
            continue;
          }
          cnt++;
        }
      }
      for (let j = 1; j < 8; j++) {
        if (!data[j].word_top && !data[j].word_bottom) continue;
        let randI = getFieldRandomIndex();

        let tmp_word;

        if (data[j].word_bottom && j > 3 && data[j].word_top) {
          tmp_word = data[j].word_top + " " + data[j].word_bottom;
          field_data_arr[randI] = {
            isNextGrid: false,
            isWord: true,
            isTrap: false,
            contents: tmp_word,
            player: "",
            checked: "",
            word_top: data[j].word_top,
            word_bottom: data[j].word_bottom,
            explanation: data[j].explanation,
            part_of_speech: data[j].part_of_speech,
          }
          continue;
        }
        else if (data[j].word_bottom && data[j].word_top && j != 2) {
          tmp_word = data[j].word_top;
          field_data_arr[randI] = {
            isNextGrid: false,
            isWord: true,
            isTrap: false,
            contents: tmp_word,
            player: "",
            checked: "",
            word_top: data[j].word_top,
            word_bottom: data[j].word_bottom,
            explanation: data[j].explanation,
            part_of_speech: data[j].part_of_speech,
          }

          randI = getFieldRandomIndex()
          tmp_word = data[j].word_bottom;
          field_data_arr[randI] = {
            isNextGrid: false,
            isWord: true,
            isTrap: false,
            contents: tmp_word,
            player: "",
            checked: "",
            word_top: data[j].word_top,
            word_bottom: data[j].word_bottom,
            explanation: data[j].explanation,
            part_of_speech: data[j].part_of_speech,
          }
          continue;
        }
        else if (data[j].word_bottom && !data[j].word_top) {
          tmp_word = data[j].word_bottom;
        } else if (data[j].word_bottom && j == 2 && data[j].word_top) {
          tmp_word = data[j].word_bottom;
        } else if (data[j].word_top) {
          tmp_word = data[j].word_top;
        }
        field_data_arr[randI] = {
          isNextGrid: false,
          isWord: true,
          isTrap: false,
          contents: tmp_word,
          player: "",
          checked: "",
          word_top: data[j].word_top,
          word_bottom: data[j].word_bottom,
          explanation: data[j].explanation,
          part_of_speech: data[j].part_of_speech,
        }

      }

      //　トラップの配置
      for (let i = 0; i < fieldSettings.trap_len; i++) {
        let randI;
        while (1) {
          //ランダムなindexを取得
          const fieldI = 1 + Math.floor(Math.random() * fieldIndex.length);
          randI = fieldIndex[fieldI];
          if (randI != undefined && randI != 0 && randI && randI != null && fieldIndex[fieldI] != "word" && fieldIndex[fieldI] != "trap") {
            fieldIndex[fieldI] = "trap";
            // i番目の要素を削除
            fieldIndex.splice(fieldI, 1);
            break;
          }
        }

        let trapId;
        while (1) {
          trapId = trapIdListForRandom[Math.floor(Math.random() * trapIdListForRandom.length)];
          if (level === "easy") {
            if (trapId === 4) { // easy はゲームオーバーのトラップマスを扱わない
              continue;
            } else {
              break;
            }
          } else {
            break;
          }
        }
        field_data_arr[randI] = {
          isNextGrid: false, isWord: false, isTrap: true, contents: trapIdToNameTable[trapId], player: "", checked: "",
        }
      }

      setFieldData(field_data_arr);
      setIsFieldCreated(true);
      setInterval(() => { setIsLoading(false); }, 1000)


    }).catch((err) => {
      console.error("Error:", err);
    })

  }


  //　残りの数を管理
  const countNum = (mode, level) => {
    // 初期化する
    const initCnt = () => {
      switch (level) {
        case "easy":
          setCnt(30);
          break;
        case "hard":
          setCnt(30);
          break;
        case "normal":
          setCnt(30);
          break;

        default:
          console.error("進める数が初期化されませんでした。");
          return;
      }
      return;
    }

    // −１する
    const decCnt = () => {
      if (cnt - 1 < 0) {
        setGameStatusValue(8);
        return;
      }
      setCnt(cnt - 1);
      return cnt;
    }

    switch (mode) {
      case "init":
        initCnt();
        break;

      case "dec":
        decCnt();
        break;

      default:
        console.error("CountNum関数において、許可されていないモードです。");
        return;
    }

  }

  // createFieldDataArrayをコンポーネント読み込み時に実行する(初期化)
  useEffect(() => {
    createFieldDataArray()
      .catch((err) => {
        console.error("Error:", err)
      });
    countNum("init", level)
  }, []);

  // playerが移動したら表示内容を更新する。プレイヤーのバックパックを更新する。
  useEffect(() => {
    if (!isLoading) {
      countNum("dec");// 進める回数を減らす
      let tmpFieldArr = [...fieldData];
      for (let i = 0; i < tmpFieldArr.length; i++) {
        if (i === playerCurrentSquare) {
          tmpFieldArr[playerCurrentSquare] = {
            isNextGrid: false,
            isWord: fieldData[playerCurrentSquare].isWord,
            isTrap: fieldData[playerCurrentSquare].isTrap,
            contents: fieldData[playerCurrentSquare].contents,
            player: "player1",
            checked: "✅",
            word_top: fieldData[playerCurrentSquare].word_top,
            word_bottom: fieldData[playerCurrentSquare].word_bottom,
            explanation: fieldData[playerCurrentSquare].explanation,
            part_of_speech: fieldData[playerCurrentSquare].part_of_speech,
          }
          /** 配列内で値が重複してないか調べる 重複→ true**/
          function existsSameValue(a) {
            for (let i = 0; i < a.length; i++) {
              for (let j = 0; j < a.length; j++) {
                if (i != j && a[i].contents === a[j].contents) {
                  return true;
                }
              }
            }
            return false;
          }
          //　単語情報をプレイヤーのバックパックに追加
          if (tmpFieldArr[i].isWord) {
            const tmpPlayerHasWordsArr = [...playerHasWords];
            tmpPlayerHasWordsArr.push(tmpFieldArr[i]);
            if (!existsSameValue(tmpPlayerHasWordsArr)) {
              setPlayerHasWords(tmpPlayerHasWordsArr);
              setGameStatusInfo(`${tmpFieldArr[i].contents}を取得しました。`);
            } else {
              setGameStatusInfo("取得済みの単語です。");
            }

          }
          // else if (tmpFieldArr[i].isTrap) {
          // トラップますを踏んだ時は./Trap/TrapMain.jsxにおいてGameStatusInfoを更新
          // }
        } else {
          if (tmpFieldArr[i].player) {
            tmpFieldArr[i] = {
              isNextGrid: false,
              isWord: fieldData[i].isWord,
              isTrap: fieldData[i].isTrap,
              contents: fieldData[i].contents,
              player: "",
              checked: "✅",
              word_top: fieldData[i].word_top,
              word_bottom: fieldData[i].word_bottom,
              explanation: fieldData[i].explanation,
              part_of_speech: fieldData[i].part_of_speech,
            }
          } else if (!tmpFieldArr[i].checked) {
            tmpFieldArr[i] = {
              isNextGrid: false,
              isWord: fieldData[i].isWord,
              isTrap: fieldData[i].isTrap,
              contents: fieldData[i].contents,
              player: "",
              checked: "",
              word_top: fieldData[i].word_top,
              word_bottom: fieldData[i].word_bottom,
              explanation: fieldData[i].explanation,
              part_of_speech: fieldData[i].part_of_speech,
            }
          }
        }

      }
      setFieldData(tmpFieldArr);
    }
  }, [playerCurrentSquare]);

  // player1のデータ
  const player1 = {
    color: "blue",
  }

  let actionWindow;

  if (!isPC) {
    actionWindow = css`
      display: ${actionWindowDisplay};
      position: absolute;
      top: 0;
      left: 0;
      width: 100vw;
      height: 100vh;
      background-color: white;
      z-index: 99999;

      .close-btn {
        position: absolute;
        top: 15px;
        right: 15px;
        background-color: white;
        border: none;
        font-size: 1.5em;
        cursor: pointer;
      }
    `;
  } else {//通常のPCの場合
    actionWindow = css`
      position: absolute;
      top: 140px;
      right: 0;
    `;
  }
  const actionBtn = css`
    position: absolute;
    right: 10px;
    top: 75px;
    border-radius: 10px;
    background-color: white;
    border: .5 solid gray;
    width: 60px;
    height: 60px;
  `;

  const gameMainStyle = css`
    height: 100vh;
    width: 100vw;
    overflow: hidden;
  `;



  return (
    <>
      <div>
        {
          isLoading ? (
            <Loading isFieldCreated={isFieldCreated} />
          ) : (
            <>
              <div css={gameMainStyle}>
                <SentenceWindow sentence={sentence} />
                <GameOver />

                <Sentence sentence={sentence} />

                <div css={actionWindow}>
                  {
                    !isPC ? <button className="close-btn" onClick={() => {
                      setActionWindowDisplay("none");
                    }}>X</button> : ""
                  }
                  <div className='backpack-smartphone'><BackPack playerHasWords={playerHasWords} sentenceLen={sentence.sentence_len} /></div>
                  <Items fieldData={fieldData} />
                </div>
                <TrapMain />
                {/* スマホ用アクションボタン */}
                {!isPC ? <img src={Honeycomb} alt="アクションボタン" css={actionBtn} onClick={() => {
                  if (actionWindowDisplay === "none") {
                    setActionWindowDisplay("block");
                  }
                }} /> : ""}
                <Field field_data={fieldData} player1={player1} cnt={cnt} />
                <HoneycombSet playerHasWords={playerHasWords} />

              </div>
            </>
          )
        }
      </div>
    </>

  )
}

export default TeacherGameMain
